import AdvertisingOptionGdprChoiceView from './AdvertisingOptionGdprChoiceView';
import AdvertisingOptionGdprPartnerListView from './AdvertisingOptionGdprPartnerListView';
import getStore from '../store/getStore';
import { observer } from 'mobx-react';
import * as React from 'react';

@observer
export default class AdvertisingOptionFull extends React.Component<{}, {}> {
    render() {
        if (getStore().showGdprPartnerListView) {
            return <AdvertisingOptionGdprPartnerListView vendorList={getStore().vendorList} />;
        } else {
            return <AdvertisingOptionGdprChoiceView />;
        }
    }
}
